import { useMediaQuery } from "@mui/system";
import {
  SimpleShowLayout,
  TextField,
  NumberField,
  Labeled,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const BasicInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Име на български">
            <TextField source="nameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Име на английски">
            <TextField source="nameEn" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Код">
            <TextField source="code" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Категория труд">
            <ReferenceField
              source="laborCategory"
              reference={specialistRequests.getSpecializationLaborCategoriesSelect()}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип">
            <ReferenceField
              source="type"
              reference={specialistRequests.getSpecializationTypesSelect()}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Катедра">
            <ReferenceField
              source="departmentId"
              reference={administrationRequests.getDepartmentsSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип прием">
            <ReferenceArrayField
              source="receptionTypeIds"
              reference={administrationRequests.getReceptionTypesSelect()}
            >
              <SingleFieldList linkType={false}>
                <ChipField
                  source="name"
                  size="small"
                />
              </SingleFieldList>
            </ReferenceArrayField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Продължителност на обучение (месеци)">
            <NumberField source="studyDuration" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Коефициент за увеличение на заплата">
            <NumberField source="wageIncreaseCoefficient" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Номер заповед">
            <TextField source="ordinanceNumber" />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default BasicInfoSection;
